import React from "react";
import {
  Card,
  CardActionArea,
  Typography,
  Box,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import FolderIcon from "@mui/icons-material/Folder";

// Thumbnail variant
export function FolderThumbnail({ folder, onOpen, isDropTarget, onDropCollection, onDragOver, onDragLeave }) {
  return (
    <Card
      variant="outlined"
      sx={{
        height: "100%",
        cursor: "pointer",
        borderColor: isDropTarget ? "primary.main" : "divider",
        borderWidth: isDropTarget ? 2 : 1,
        borderStyle: isDropTarget ? "dashed" : "solid",
        bgcolor: isDropTarget ? "primary.light" : "transparent",
        opacity: isDropTarget ? 0.8 : 1,
        transition: "border-color 0.15s ease, background-color 0.15s ease, opacity 0.15s ease",
        position: "relative",
      }}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDropCollection}
    >
      <CardActionArea onClick={onOpen} sx={{ height: "100%", p: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1 }}>
          <FolderIcon sx={{ color: "primary.main", fontSize: 32 }} />
          <Typography variant="subtitle2" fontWeight="bold" noWrap>
            {folder.name}
          </Typography>
        </Box>
        <Typography variant="caption" color="text.secondary">
          {folder.count} {folder.count === 1 ? "item" : "items"}
        </Typography>
      </CardActionArea>
    </Card>
  );
}

// List variant
export function FolderListRow({ folder, onOpen, isDropTarget, onDropCollection, onDragOver, onDragLeave }) {
  return (
    <ListItemButton
      onClick={onOpen}
      sx={{
        borderLeft: isDropTarget ? "3px solid" : "3px solid transparent",
        borderColor: isDropTarget ? "primary.main" : "transparent",
        bgcolor: isDropTarget ? "primary.light" : "transparent",
        opacity: isDropTarget ? 0.8 : 1,
      }}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDropCollection}
    >
      <ListItemIcon>
        <FolderIcon sx={{ color: "primary.main" }} />
      </ListItemIcon>
      <ListItemText
        primary={folder.name}
        secondary={`${folder.count} ${folder.count === 1 ? "item" : "items"}`}
      />
    </ListItemButton>
  );
}
